import PropTypes from 'prop-types';
import React from 'react';

import Button from 'gd-comp-button';

const debug = {
    dev: false,
    head: '[Form BtnSubmit]'
};

const propTypes = {
    onClick: PropTypes.any,
    label: PropTypes.string.isRequired,
    className: PropTypes.string,
    size: PropTypes.string,

    icon: PropTypes.string,
    iconPosition: PropTypes.oneOf(['left','right']),

    form: PropTypes.object.isRequired,

    hideIfDisabled: PropTypes.bool // hide (no render) when form not ready for submit
};

const defaultProps = {
    iconPosition: 'left'
};

class ButtonSubmit extends React.Component {

    constructor(props) {
        super(props);

        // this._bind('onClick');
    }

    componentDidMount() {
        this.props.form.registerSubmitButton(this);
    }

    onClick = (e) => {
        e.stopPropagation();

        if (this.props.type === 'busy') {
            e.preventDefault();
        } else {
            //this.props.onClick(e);
            this.props.form.onSubmitClick.call(this.props.form);
        }
    };

    render() {
        const { form, hideIfDisabled } = this.props;

        let type = 'primary';

        if (form.isSubmitting) type = "busy";
        else if (form.isFormValid && form.isFormChanged) type = "primary";

        if (hideIfDisabled === true && type !== 'primary' && type !== 'busy') return false;

        if (debug.dev) console.log(debug.head, ".render() TYPE=", type, " formIsSubmitting=", this.props.form.isSubmitting, " formIsValid=", this.props.form.isFormValid, " formIsChanged=", this.props.form.isFormChanged);

        return (
            <Button onClick={this.onClick}
                    size={this.props.size}
                    type={type}
                    label={this.props.label}
                    icon={this.props.icon}
                    iconPosition={this.props.iconPosition}
                    className={this.props.className}/>
        );

    }
}

ButtonSubmit.propTypes = propTypes;
ButtonSubmit.defaultProps = defaultProps;

module.exports = ButtonSubmit;